.CalendarDay,
.CalendarDay--blocked-minimum-nights,
.CalendarDay--blocked-out-of-range {
  border-color: var(--default--border-color--4);
}

.CalendarDay {
  color: var(--dark--text-color--1);
  border: 0;
  font-size: 14px;
  line-height: 14px;
}

.CalendarDay--highlighted-calendar {
  color: var(--primary--message--text-color--6);
}

.CalendarDay--highlighted-calendar:active {
  background: var(--primary--active--background-color--2);
}

.CalendarDay--hovered {
  background: var(--primary--hover--background-color--2);
}

.CalendarDay--blocked-minimum-nights,
.CalendarDay--blocked-out-of-range {
  color: var(--default--text-color--1);
}

.CalendarDay--selected-span {
  background: var(--primary--selected--background-color--2);
  border-color: var(--primary--selected--border-color--1);
}

.CalendarDay--selected-span.CalendarDay--hovered,
.CalendarDay--selected-span:active {
  background: var(--primary--selected--background-color--2);
}

.CalendarDay--selected-span.CalendarDay--last-in-range {
  border-right: var(--primary--selected--border-color--1);
}

.CalendarDay--hovered-span,
.CalendarDay--after-hovered-start {
  background: var(--primary--hover--background-color--2);
  color: var(--primary--hover--text-color--1);
}

.CalendarDay--hovered-span:active,
.CalendarDay--after-hovered-start:active {
  background: var(--primary--active--background-color--2);
}

.CalendarDay--selected-start,
.CalendarDay--selected-end,
.CalendarDay--selected {
  background: var(--primary--selected--background-color--3);
}

.CalendarDay--selected-start:active,
.CalendarDay--selected-end:active,
.CalendarDay--selected:active {
  background: var(--primary--selected--background-color--3);
}

.CalendarDay--blocked-calendar {
  background: var(--default--background-color--8);
  color: var(--default--text-color--3);
}

.CalendarDay--blocked-calendar:active {
  background: var(--default--background-color--8);
}

.CalendarMonth_caption {
  color: var(--default--text-color--4);
  font-size: 14px;
  line-height: 14px;
  padding-top: 17px;
  padding-bottom: 27px;
}

.CalendarMonth_caption > * {
  font-weight: var(--font-weight-normal);
}

.DayPicker_weekHeader {
  top: 40px;
}

.DayPicker__week-header {
  color: var(--default--text-color--2);
}

.DayPicker--vertical-scrollable .DayPicker__week-header {
  border-bottom: 1px solid var(--default--border-color--1);
}

.DayPickerNavigation__prev--default,
.DayPickerNavigation__next--default {
  border-color: var(--default--border-color--10);
  color: var(--default--text-color--2);
}

.DayPickerNavigation__prev--default:focus,
.DayPickerNavigation__prev--default:hover,
.DayPickerNavigation__next--default:focus,
.DayPickerNavigation__next--default:hover {
  border-color: var(--default--border-color--1);
}

.DayPickerNavigation__prev--default:active,
.DayPickerNavigation__next--default:active {
  background: var(--default--background-color--1);
}

.DayPickerNavigation--horizontal .DayPickerNavigation__prev--default svg,
.DayPickerNavigation--horizontal .DayPickerNavigation__next--default svg {
  fill: var(--default--icon--fill-color--5);
}

.DayPickerNavigation--vertical .DayPickerNavigation__prev--default svg,
.DayPickerNavigation--vertical .DayPickerNavigation__next--default svg {
  fill: var(--default--icon--fill-color--5);
}

.KeyboardShortcutRow__key {
  background: var(--default--icon--fill-color--5);
}

.DateInput--disabled {
  background: var(--default--input--disabled--background-color--2);
}

.DateRangePicker__close svg {
  fill: var(--default--icon--fill-color--5);
}

.DateRangePicker__close:hover,
.DateRangePicker__close:focus {
  color: var(--react-dates--date-range-picker--hover--icon-color);
}

.DateRangePickerInput {
  border-color: var(--default--input--border-color--3);
}

.DateRangePickerInput--disabled {
  background: var(--default--input--disabled--background-color--2);
}

.DateRangePickerInput__arrow svg {
  fill: var(--default--icon--fill-color--5);
}

.DateRangePickerInput__clear-dates svg {
  fill: var(--default--icon--fill-color--5);
}

.DateRangePickerInput__clear-dates:focus,
.DateRangePickerInput__clear-dates--hover {
  background: var(--light--button--disabled--background-color--1);
}

.PresetDateRangePicker_button__calendar-icon svg {
  fill: var(--default--icon--fill-color--5);
}

.SingleDatePicker__close svg {
  fill: var(--default--icon--fill-color--9);
}

.SingleDatePicker__close:hover,
.SingleDatePicker__close:focus {
  color: var(--light--icon--fill-color--1);
}

.SingleDatePickerInput__clear-date:focus,
.SingleDatePickerInput__clear-date--hover {
  background: var(--light--input--hover--background-color--1);
}

.SingleDatePickerInput {
  border: 0;
  background: transparent;
  display: block;
}

.SingleDatePicker__picker--direction-left {
  /* this important is needed because the js puts a left on the element. */
  left: -100px !important;
}

.SingleDatePickerInput__calendar-icon {
  margin: 0;
  padding: 0;
  height: 30px;
  vertical-align: top;
}

.SingleDatePickerInput__calendar-icon svg {
  height: 30px;
  width: 30px;
  fill: var(--default--icon--fill-color--5);
}

.SingleDatePicker__picker {
  top: 100%;
  margin-top: 5px;
}

.SingleDatePicker_picker {
  position: static !important;
}

.DateInput,
.DayPickerKeyboardShortcuts__show,
.DateInput__input,
.DateInput__display-text {
  display: none;
}

.DayPickerNavigation {
  display: flex;
  justify-content: space-between;
  padding: 0 22px;
}

.DayPickerNavigation > * {
  padding: 0;
  margin: 0;
  border: 0;
  background: transparent;
}

.DayPickerNavigation > *:focus {
  outline: none;
}

.DayPickerNavigation > *:hover svg {
  background: var(--react-dates--day-picker-navigation--hover--icon-background-color);
  color: var(--default--icon--fill-color--5);
}

.DayPickerNavigation > * svg {
  width: 14px;
  height: 18px;
  color: var(--default--icon--fill-color--5);
  display: inline-block;
  /* margin-bottom compensates for a react-dates rendering bug */
  margin-bottom: -4px;
}

.DayPicker__week-header li small {
  font-size: 14px;
  line-height: 14px;
}

.DayPickerNavigation--horizontal .DayPickerNavigation__prev,
.DayPickerNavigation--horizontal .DayPickerNavigation__next {
  border-radius: 0;
  padding: 0;
}

.CalendarDay__button {
  border: 4px solid var(--light--border-color--1);
}

.CalendarDay--selected {
  color: var(--light--text-color--1);
}

.SingleDatePickerInput_calendarIcon {
  height: 30px;
  margin: 0;
  padding: 0;
}

.CalendarDay__selected {
  color: var(--light--text-color--1);
  background: var(--primary--button--selected--background-color--1);
}

.DayPickerNavigation_button {
  background-color: transparent;
  border: 0;
  height: 30px;
  margin-top: 10px;
}

.DayPicker_transitionContainer {
  min-height: 256px;
}
